import React, { useEffect, useState } from 'react';
import { Form, Input, Select } from 'antd';
import { ICountryOrState, IUserAddressRulesField } from 'base/interfaces/address';
import { getFormItemRules } from '@base/account/address/utils';
import Iconfont from '@base/lib/Iconfont';
import { useTrans } from 'base/utils/i18n';
import { useRequest } from 'ahooks';
import Fuse from 'fuse.js';

type IProps = {
    onSelectProvinceHandle: (provinceText: string) => void;
    itemRules: IUserAddressRulesField;
    currentCountryObj?: ICountryOrState;
}

const ProvinceFormItem: React.FC<IProps> = (props) => {
    const {
        itemRules,
        currentCountryObj,
        onSelectProvinceHandle
    } = props;
    const {
        key,
        labelTitle,
        placeholder,
        inputType,
    } = itemRules;

    const isTextInput = inputType == 'text'

    const { t } = useTrans();

    const [provinceList, setProvinceList] = useState<ICountryOrState[] | undefined>(currentCountryObj?.children);

    const onDropdownVisibleChangeHandle = () => {
        setProvinceList(currentCountryObj?.children || [])
    }

    const onSearch = async (newValue: string) => {
        const list = currentCountryObj?.children || [];
        if (!newValue) {
            setProvinceList(list);
        }

        const fuse = new Fuse(list, {
            isCaseSensitive: false,
            keys: [
                'name',
                'code'
            ]
        });
        const matchedList = fuse.search(newValue);
        setProvinceList(matchedList.map(item=>item.item));
    }

    const { run: onSearchDebounce } = useRequest(onSearch, {
        debounceWait: 400,
        manual: true,
    })

    useEffect(() => {
        setProvinceList(currentCountryObj?.children || [])
    }, [currentCountryObj]);

    return (
        <Form.Item
            // dependencies={['countryText']}
            label={labelTitle}
            name={key}
            rules={getFormItemRules(itemRules)}
        >
            {
                isTextInput ? (
                    <Input
                        autoComplete="no-fill"
                        placeholder={placeholder}
                    />
                ) : (
                    <Select
                        // @ts-ignore
                        autoComplete="no-fill" // off 无效
                        placeholder={placeholder}
                        showSearch
                        filterOption={false}
                        getPopupContainer={trigger => trigger.parentElement}
                        notFoundContent={<p>{t('web_common_it_is_empty')}</p>}
                        onDropdownVisibleChange={onDropdownVisibleChangeHandle}
                        onChange={(e) => onSelectProvinceHandle(e)}
                        onSearch={(value) => onSearchDebounce(value)}
                        suffixIcon={<Iconfont className={'select-arrow icon-arrow-down'}/>}
                        // @ts-ignore, api 中没有该属性定义但实际支持
                        autoComplete={'no-fill'}
                        options={provinceList?.map((oItem: any) => {
                            return {
                                value: oItem?.name,
                                label: oItem?.name,
                            }
                        })}
                    />
                )
            }
        </Form.Item>
    );
};

export default ProvinceFormItem
